import type { CategoryContent } from '../row.js';

export const ANATOMY: CategoryContent = {
  bscba: [
    [
      'Hoeveel hoofdtypen bot worden in de menselijke anatomie onderscheiden op basis van hun vorm?',
      [
        'Vier: lang, kort, plat en onregelmatig',
        'Drie: lang, kort en plat',
        'Vijf: lang, kort, plat, onregelmatig en sesamoïd',
        'Zes: lang, kort, plat, onregelmatig, pneumatisch en dicht',
      ],
      0,
      'Botten worden op basis van vorm in vier typen ingedeeld: lang (femur), kort (carpalen), plat (borstbeen) en onregelmatig (wervels).',
    ],
    [
      'Welke van de volgende beschrijvingen past het best bij de structuur van een synoviaal gewricht?',
      [
        'Botuiteinden met hyaline kraakbeen in een vloeistofkapsel',
        'Botten bij elkaar gehouden door vezelig bindweefsel zonder ruimte ertussen',
        'Kraakbeenachtige schijf die twee botuiteinden volledig laat samensmelten',
        'Twee botten verbonden door elastische ligamenten die een semi-mobiel gewricht vormen',
      ],
      0,
      'Synoviale gewrichten hebben hyaline kraakbeen op articulaire oppervlakken, een synoviaal membraan in de kapsel en synoviale vloeistof voor smering.',
    ],
    [
      'Wat is het primaire structurele verschil tussen Type I en Type II spiervezels?',
      [
        'Type I is slow-twitch en oxidatief; Type II is fast-twitch en glycolytisch',
        'Type I vezels worden uitsluitend in het hart gevonden; Type II in skeletspier',
        'Type II vezels bevatten meer mitochondriën en voeren aëroob metabolisme uit',
        'Type I vezels hebben dikkere myofilamenten en genereren meer kracht',
      ],
      0,
      'Type I-vezels blinken uit in duurzame activiteit met lage krachtsontwikkeling via oxidatief metabolisme. Type II-vezels specialiseren zich in snelle, krachtige contracties via glycolyse.',
    ],
    [
      'Welke twee grote bloedvaten bereiken het rechter atrium?',
      [
        'Bovenste en onderste holle aderen',
        'Linker- en rechterpulmonale slagaders',
        'Linker- en rechterpulmonale aders',
        'Aorta en coronair sinus',
      ],
      0,
      'De bovenste holle ader draineert hoofd, nek en bovenste ledematen; de onderste holle ader draineert alles onder het diafragma.',
    ],
    [
      'Welke hartkamer heeft de dikste myocardiale wand?',
      [
        'Linker ventrikel',
        'Rechter ventrikel',
        'Linker atrium',
        'Rechter atrium',
      ],
      0,
      'De linker ventrikel pompt bloed tegen hoge weerstand, wat dikke wanden (8–15 mm) vereist. De rechter ventrikel is dunner (2–5 mm).',
    ],
    [
      'Wat is de naam van de buis waar bloed van het hart naar het lichaam stroomt?',
      [
        'Aorta',
        'Halsslagader',
        'Pulmonale slagader',
        'Sleutelbeenarterie',
      ],
      0,
      'De aorta is de grootste slagader; hij ontspringt uit de linker ventrikel en vertakt zich naar alle weefsels.',
    ],
    [
      'Op welk anatomisch punt splitst de luchtpijp zich in twee primaire bronchi?',
      [
        'De carina',
        'De glottis',
        'De hilum',
        'De sternale hoek',
      ],
      0,
      'De carina is de nok waar de luchtpijp zich op T4-T5-wervelhoogte splitst in de linker- en rechterhoofdbronchus.',
    ],
    [
      'Hoeveel lobben heeft de rechterlong?',
      [
        'Drie',
        'Twee',
        'Vier',
        'Vijf',
      ],
      0,
      'De rechterlong heeft drie lobben (boven, midden, onder), gescheiden door schuine en horizontale fissuren. De linkerlong heeft slechts twee lobben.',
    ],
    [
      'Welke structuur voorkomt dat voedsel tijdens het slikken in de luchtpijp komt?',
      [
        'Epiglottis',
        'Zachte gehemelte',
        'Arytenoïde kraakbeen',
        'Stemlippen',
      ],
      0,
      'De epiglottis is een bladvormig kraakbeen dat zich tijdens het slikken over de larynxingang vouwt, wat de luchtweg beschermt.',
    ],
    [
      'Wat voor soort epitheel bekleedt de slokdarm?',
      [
        'Meerlagig plaveiselepitheel',
        'Eenvoudig kubisch epitheel',
        'Overgangsepitheel',
        'Pseudogelaagd trilharig epitheel',
      ],
      0,
      'Meerlagig plaveiselepitheel is bestand tegen mechanische schuring door voedsel en mist de klieren en plooien van de maag.',
    ],
    [
      'Wat is de primaire functie van de fundus van de maag?',
      [
        'Maagsapafscheiding',
        'Voedselopslag en het starten van de menging',
        'Besturing van de pylorische sfincter',
        'Opname van voedingsstoffen',
      ],
      0,
      'De fundus bevat maagklieren (wand-, hoofd- en slijmklieren) die zuur, pepsine en beschermend slijm afscheiden.',
    ],
    [
      'Waar is de lever primair aan vastgehecht?',
      [
        'Diafragma via het sikkelvormige ligament',
        'Maag via het gastrohepatische ligament',
        'Milt via het gastrolienale ligament',
        'Alvleesklier via pancreaticoduodenale aders',
      ],
      0,
      'Het sikkelvormige ligament (ventrale mesenterium) en coronaire ligamenten hechten de lever aan het diafragma en de voorste buikwand.',
    ],
    [
      'Hoe worden de functionele filtereenheden van de nier genoemd?',
      [
        'Nefronen',
        'Glomeruli',
        'Tubuli',
        'Piramiden',
      ],
      0,
      'Elk nefron bestaat uit een renaal corpusculum (glomerulus + kapsel van Bowman) en een renale tubulus. De nier bevat ongeveer 1 miljoen nefronen.',
    ],
    [
      'Welk niergebied bevat de glomeruli en proximale gewonden tubuli?',
      [
        'Nierschors',
        'Niermerg',
        'Nierbecken',
        'Nierkolom',
      ],
      0,
      'De nierschors bevat alle glomeruli en proximale/distale gewonden tubuli. Het merg bevat de Henle-lus en verzamelbuizen.',
    ],
    [
      'Wat is de anatomische term voor waar een spier aan het bewegende bot hecht?',
      [
        'Aanhechting',
        'Oorsprong',
        'Spierbuik',
        'Fascie',
      ],
      0,
      'De aanhechting is de plek waar de spier aan het bewegende bot hecht (meestal distaal). De oorsprong is de vaste aanhechting (meestal proximaal). Beide heten enthesen.',
    ],
  ],
  msc: [
    [
      'Waaruit bestaat het Haversian systeem in de microstructuur van compact bot?',
      [
        'Concentrische lamellen rond een kanaal met vaten en zenuwen',
        'Radiërende trabeculae van sponsbot ondersteund door een dichte buitenschaal',
        'Langsgerichte rijen van osteocyten ingebed in evenwijdige collageenvezels',
        'Onderling verbonden holten gevoerd door osteoblasten en gescheiden door gemineraliseerde septa',
      ],
      0,
      'Een Haversian (osteon) systeem is de kleinste structurele eenheid: concentrische ringen van botmatrix (lamellen) rond een osteonkanaal.',
    ],
    [
      'Uit welke kiemlaag ontstaat embryologisch het synoviale membraan van gewrichten?',
      [
        'Laterale plaat mesoderm',
        'Paraxiale mesoderm',
        'Ectoderm',
        'Endoderm',
      ],
      0,
      'Het synoviale membraan en gewrichtscapsule ontwikkelen zich uit laterale plaat (somatische) mesoderm rond het ontwikkelende kraakbeenmodel.',
    ],
    [
      'Welk collageentype vormt het merendeel van het fibrokraakbeen in de pees-botaanhechting?',
      [
        'Type I collageen',
        'Type II collageen',
        'Type III collageen',
        'Type IV collageen',
      ],
      0,
      'Type I-collageen domineert het fibrokraakbeen van de enthesis, georganiseerd in gegradeerde zones (pees, ongecalcificeerd kraakbeen, bot).',
    ],
    [
      'In spierfysiologie, wat is de structurele relatie tussen Z-schijf en dunne filamenten?',
      [
        'Dunne filamenten verankeren aan Z-schijven en overlappen in het midden',
        'Dunne filamenten strekken zich uit van Z-schijven naar myosinekoppen in de A-band',
        'Z-schijven bestaan geheel uit actine en tropomyosinemoleculen',
        'Dunne filamenten zijn loodrecht op Z-schijven bevestigd via titinemoleculen',
      ],
      0,
      'Dunne filamenten zijn via α-actinine en CapZ-eiwitten verankerd aan Z-schijven en strekken zich uit naar de M-lijn. Dit bepaalt de sarcomeerlengte.',
    ],
    [
      'De coronaire circulatie wordt vooral gevoed door takken van welke vaten vanuit de aorta?',
      [
        'L/R kroonslagaders',
        'Tussenribslagaders',
        'Interne borstbeenslagader',
        'Longarteriële takken',
      ],
      0,
      'De linker- en rechterkroonslagaders ontspringen uit sinussen van Valsalva (aortaklepaanhechtingspunten) en voeden myocardium en epicardium.',
    ],
    [
      'Welke anatomische structuur vertraagt geleiding tussen atria en ventrikels?',
      [
        'AV-knoop',
        'Sinusknoop',
        'His bundel',
        'Purkinje vezels',
      ],
      0,
      'De AV-knoop heeft langzame geleiding (~0,05 m/s) door kleine celdiameter en schaarse gap junctions, zodat de atria eerst kunnen samentrekken.',
    ],
    [
      'Welke organen voeren bloed rechtstreeks via de portalader naar de lever?',
      [
        'Darmkanaal en milt',
        'Hart en longen',
        'Nieren en bijnierkliertjes',
        'Hersenen en ruggenmerg',
      ],
      0,
      'De portalader voert bloed van het maagdarmkanaal af en levert voedselrijk bloed aan hepatocyten voor eerste-passagemetabolisme.',
    ],
    [
      'Wanneer het diafragma samentrekt, wat gebeurt er met de intrapulmonale druk?',
      [
        'De druk wordt negatief (subatmosferisch)',
        'De druk stijgt boven atmosferische druk',
        'De druk blijft constant',
        'De druk wordt gelijk aan atmosferische druk',
      ],
      0,
      'Diafragmacontractie vergroot het thoraxvolume, waardoor de intrapulmonale druk negatief wordt. Lucht stroomt vervolgens naar binnen, de drukgradiënt volgend.',
    ],
    [
      'Wat is er uniek aan het bloed dat pulmonale slagaders vervoeren?',
      [
        'Zuurstofarm bloed',
        'Zuurstofrijk bloed',
        'Gemengd arterieel en veneus bloed',
        'Lymphvocht',
      ],
      0,
      'Pulmonale slagaders zijn de enige systemische slagaders die zuurstofarm bloed vervoeren, van de rechter ventrikel naar de longen, voor gasuitwisseling.',
    ],
    [
      'Wat houdt de gastro-esofageale overgang normaal gesloten?',
      [
        'De LES',
        'Bovenste slokdarmsfincter',
        'Pylorische sfincter',
        'Ileocecale klep',
      ],
      0,
      'De LES is een zone van gladde spier met hoge druk (30–40 mmHg), geïnnerveerd door de nervus vagus. Hij gaat open tijdens het slikken.',
    ],
    [
      'De bloed-testisbarrière ontstaat door strakke juncties tussen welk celtype?',
      [
        'Sertoli cellen',
        'Leydig cellen',
        'Spermatogonia',
        'Peritubulaire myoïde cellen',
      ],
      0,
      'Strakke juncties tussen Sertolicellen vormen de bloed-testisbarrière, die basale spermatogonia scheidt van meiotische kiemcellen.',
    ],
    [
      'Welke embryologische kiemlaag geeft aanleiding tot het urogenitale systeem?',
      [
        'Intermediaire mesoderm',
        'Laterale plaat mesoderm',
        'Paraxiale mesoderm',
        'Endoderm',
      ],
      0,
      'Intermediaire mesoderm (tussen paraxiale en laterale plaat mesoderm) geeft aanleiding tot nieren, ureters, gonaden en geslachtskanalen.',
    ],
    [
      'Welke twee vaten verbindt de ductus arteriosus embryologisch?',
      [
        'Pulmonale slagader naar aorta',
        'Bovenste naar onderste holle ader',
        'Navelstrengslagader naar portalader',
        'Linker atrium naar rechter atrium',
      ],
      0,
      'De ductus arteriosus omzeilt de niet-functionele foetale longen door bloed van de pulmonale slagader naar de aortaboog te leiden. Hij sluit na de geboorte.',
    ],
    [
      'Welke structuur omgeeft het perimysium?',
      [
        'Spiervezelgroepjes',
        'Individuele spiervezels',
        'De gehele skeletspier',
        'Myofilamenten in sarcomeer',
      ],
      0,
      'Perimysium omhult groepjes spiervezels om hun ordening te ondersteunen. Endomysium omgeeft individuele vezels; epimysium omgeeft de gehele spier.',
    ],
    [
      'De portaltriade in leverhistologie bestaat uit welke drie structuren?',
      [
        'Leverarterie, portalader en galbuis',
        'Leverader, leverarterie en galbuis',
        'Sinusoid, hepatocyt en Kupffer cel',
        'Centraallobulaire ader, stellaat cel en galkanaal',
      ],
      0,
      'Elke portaltriade (in hoeken van leverlobuli) bevat een tak van leverarterie, portalader en galbuis die parallel lopen.',
    ],
  ],
  phd: [
    [
      'Botremodellering wordt gecoördineerd door welk moleculair signaalpad, geactiveerd door mechanische belasting?',
      [
        'Wnt/β-catenine via mechanotransductie',
        'Notch signalering in osteoblasten differentiatie',
        'Hedgehog signalering in osteoklasten activatie',
        'FGF receptor signalering in endochondrale osificatie',
      ],
      0,
      'Osteocyten voelen mechanische belasting via integrines en ionkanalen, activeren Wnt/β-catenine om sclerostine te onderdrukken en botvorming te bevorderen.',
    ],
    [
      'In de enthesis bevat gemineraliseerd fibrokraakbeen calciumhydroxyapatietkristallen op welke hoek ten opzichte van de collageenvezels?',
      [
        '45 graden',
        'Evenwijdig (0 graden)',
        'Loodrecht (90 graden)',
        'Willekeurig (variabele hoeken)',
      ],
      0,
      'De gecalcificeerde kraakbeenzone van de enthesis heeft apatietkristallen op ~45° ten opzichte van de collageenvezels, wat een gegradeerde mechanische overgang creëert.',
    ],
    [
      'Om welk functioneel gebied draait de myosinekop tijdens de powerstroke?',
      [
        'Het nekgebied tussen domein en hefboomarm',
        'De ATP bindingzak in nucleotide bindingnauw',
        'De actine bindingsinterface op het onderste 50 kDa domein',
        'Het regeleiwitlichte keten aan het eind van hefboomarm',
      ],
      0,
      'De nekstreek (converterdomein) van myosine werkt als hefboomscharnier. Conformatiewijzigingen vergroten kleine rotatoire bewegingen tot een grote verplaatsing.',
    ],
    [
      'De coronaire circulatie vertoont metabolische autoregulatie door welk primair mechanisme?',
      [
        'Adenosine verlaagt arterioolweerstand',
        'Myogeen respons op perfusiedrukveranderingen',
        'Sympathische systeemvasocontrictie',
        'Endotheliale stikstofmonoxideproductie door schuifspanning',
      ],
      0,
      'Verhoogde hartspierstofwisseling put ATP uit, genereert adenosine dat A2A-receptoren op gladde spier activeert, wat vasodilatatie veroorzaakt.',
    ],
    [
      'Door welk drukgradiëntmechanisme blijft de foetale shunting via het foramen ovale behouden?',
      [
        'Linkerkamerdruk overschrijdt rechterkamerdruk, waardoor de septum-primumklep open blijft',
        'Rechterkamerdruk overschrijdt linkerkamerdruk, wat bloed over het defect forceert',
        'De ductus venosus leidt bloed rechtstreeks naar de linkerkamer',
        'Preferentiële pulmonale vasculaire dilatatie verhoogt de links-naar-rechts shunting',
      ],
      0,
      'Het foramen ovale werkt als eenrichtingsklep: wanneer de linkerkamerdruk na de geboorte stijgt, sluit het septum primum het gat.',
    ],
    [
      'Accessoire respiratiespieren, inclusief scalenen en sternocleidomastoid, hechten aan welke ribben?',
      [
        'Eerste en tweede ribben',
        'Vijfde en zesde ribben',
        'Achtste tot twaalfde ribben',
        'Alle ribben gelijk van eerste tot twaalfde',
      ],
      0,
      'Scalenen hechten aan ribben 1–2; sternocleidomastoid ondersteunt rib 1. Deze spieren tillen de thoraxwand op tijdens geforceerde inademing.',
    ],
    [
      'De bloed-luchtbarrière van de alveolus bestaat uit hoeveel cellagen in totaal?',
      [
        'Drie: epitheel, basale membraan, endotheel',
        'Twee: alveolus epitheel en capillair endotheel alleen',
        'Vier: inclusief duidelijke intersticiële laag',
        'Vijf: met extra oppervlaktespanning producerende laag',
      ],
      0,
      'De barrière is ~0,5 μm dik: alveolair epitheel (type I-cellen), gefuseerde basale membranen en capillair endotheel. Deze dunheid minimaliseert de diffusieafstand.',
    ],
    [
      'In ventilatie-perfusie matching, welke anatomische factor creëert regionale bloedstroomverschillen?',
      [
        'Zwaartekracht geeft drukgradiënt door de long',
        'Differentiaalbepaling van pulmonale slagaders per lob',
        'Voorkeur bronchiaal dilatatie in apicale segmenten',
        'Ongelijke surfactantverspreiding over longgebieden',
      ],
      0,
      'Zwaartekracht creëert een verticale drukgradiënt: apicale zones (lage perfusie) hebben hoge V/Q; basale zones (hoge perfusie) hebben lage V/Q.',
    ],
    [
      'Het darmepitheel wordt elke 3–5 dagen vernieuwd door stamcelproliferatie in welke cryptstructuur?',
      [
        'Lieberkuhn crypten',
        'Brunner klieren',
        'Peyer vlekken',
        'Plicae circulares',
      ],
      0,
      'Stamcellen in de cryptbases delen zich en genereren enterocyten. Deze migreren omhoog langs de villi, worden aan de top afgevoerd en handhaven zo een continue epitheelomzetting.',
    ],
    [
      'De sphincter van Oddi regelt stroming naar welk orgaan via de grote papil van het duodenum?',
      [
        'Duodenum, via de grote papil',
        'Jejunum via ligament van Treitz',
        'Maag via pylorische sfincter',
        'Ileum via ileocecale klep',
      ],
      0,
      'De sphincter van Oddi regelt de gal- en pancreassapstroom naar het duodenum. Cholecystokinine veroorzaakt ontspanning tijdens de vertering.',
    ],
    [
      'Wat detecteert het juxtaglomerulaire apparaat en wat leidt tot renineafscheiding?',
      [
        'Lage perfusiedruk of laag natrium bij macula densa',
        'Verhoogde filteringsdruk in Bowman capsule',
        'Verhoging van glomerulaire filtratie snelheid boven basaal',
        'Hyperkaliëmie gedetecteerd door granulaire cellen',
      ],
      0,
      'Baroreceptoren in afferente arteriolen voelen hypotensie; chemoreceptoren (macula densa) voelen een laag NaCl-gehalte. Beide activeren renineafscheiding.',
    ],
    [
      'De Müller (paramesonefrische) buis geeft aanleiding tot welke vrouwelijke voortplantingsstructuren?',
      [
        'Eileiders en baarmoeder',
        'Eierstokken en follikelcellen',
        'Vagina en vestibulaire klieren alleen',
        'Clitoris en grote vestibulaire klieren',
      ],
      0,
      'De Müllerbuizen smelten caudaal samen om baarmoeder en vagina te vormen; craniaal vormen zij de eileiders. Het anti-Müllerhormoon remt deze ontwikkeling bij mannen af.',
    ],
    [
      'Wat hecht het gubernaculum testis aan tijdens testiculaire daling?',
      [
        'Het scrotum via mesenchymale condensatie',
        'De epididymis via mesorchium',
        'De interne spermatische fascie rechtstreeks',
        'Het liesligament via cremaster spier',
      ],
      0,
      'Het gubernaculum is een mesenchymale verdichting die de testis verankert aan de labioscrotale zwellingen en de transinguinale daling stuurt via differentiële groei.',
    ],
    [
      'Uit welke vier embryologische bronnen ontwikkelt het diafragma zich?',
      [
        'Septum transversum, pleuroperitonale plooien, slokdarmmesenterium, lichaamswand',
        'Laterale plaat mesoderm, intermediaire mesoderm, somatische mesoderm en endoderm',
        'Paraxiale mesoderm alleen, gesegmenteerd in phrenische somites',
        'Neurale kristcellen migrerend ventraal van hersenstam',
      ],
      0,
      'De centrale pees van het diafragma (septum transversum), de crura (dorsaal slokdarmmesenterium) en de perifere musculatuur (lichaamsrand) vormen zich tegen ongeveer week 8 van de zwangerschap.',
    ],
    [
      'In de vrouwelijke urethra, waaraan zijn parauretrale klieren (Skene-klieren) embryologisch homoloog?',
      [
        'De prostaatklier',
        'Bulbourethrale (Cowper) klieren',
        'Littré urethralekelieren',
        'Zaadblaasjes',
      ],
      0,
      'Skene-klieren ontstaan uit urethraal endoderm, net als de prostaat, waardoor ze homoloog zijn aan de prostaat. Ze scheiden een zwak zuur vocht af.',
    ],
  ],
  professor: [
    [
      'Via welk extracellulair mechanisme induceert mechanische belasting osteocytdendrieten om signalen over te dragen?',
      [
        'Vloeistofschuifspanning activeert connexine-43, wat sclerostine verlaagt',
        'Direct contact tussen osteocytuitlopers en osteoklastvoorlopers via RANKL-downregulatie',
        'Verhoogde intersticiële vloeistofdruk triggert osteoprotegerineafscheiding door naburige cellen',
        'Mechanische vervorming van integrinerijke focale adhesies die afgeschermd BMP-6 vrijstelt',
      ],
      0,
      'Osteocytdendrieten voelen vloeistofstroom door de lacunocanaliculaire netwerken. Dit activeert Wnt-signalering, verlaagt sclerostine en verhoogt de OPG/RANKL-verhouding.',
    ],
    [
      'De ultrastructurele geometrie van de gecalcificeerde fibrokraakbeenenthesis omvat apatietkristallen met een voorkeursoriëntatie. Wat is het gevolg van deze anisotropie?',
      [
        'Heterogene stress dissipeert energie aan het grensvlak',
        'Uniforme mineralisatie over de hele zone voorkomt microbarstvoortplanting in aangrenzend bot',
        'Georiënteerde kristallen verhogen de wateropname en verbeteren de viscoelastische demping',
        'Kristalanisotropie maakt snelle adaptieve remodellering mogelijk als reactie op een veranderde belastingsrichting',
      ],
      0,
      'Hoekige apatietkristallen (op 45° ten opzichte van de vezels) creëren een gegradeerde stijfheid, verspreiden spanning heterogeen en voorkomen catastrofaal falen op het grensvlak tussen pees en bot.',
    ],
    [
      'De myosine-powerstroke genereert kracht via een conformatiewijziging waarbij het converterdomein ~70° rond het nekgebied draait. Wat maakt deze overgang energetisch gunstig?',
      [
        'Fosfaatafgifte verlaagt de pre-powerstroke-energie',
        'ATP-terugbinding stabiliseert onmiddellijk de post-powerstroketoestand, wat de overgang voorwaarts drijft',
        'Actinebinding verhoogt de activeringsenergie van de omgekeerde reactie, waardoor terugstappen verwaarloosbaar wordt',
        'Thermische energie bij lichaamstemperatuur is gelijk aan ~3 pN·nm arbeid per slag',
      ],
      0,
      'Fosfaatafgifte brengt myosine naar een lagere-energietoestand, wat de powerstroke bevordert. ~50 kJ/mol energie uit ATP-hydrolyse maakt de rotatie van 70° exergoon.',
    ],
    [
      'De foetale ductus venosus laat placentabloed de hepatische sinusoïden passeren. Wat is het embryologische lot hiervan na de geboorte, en welke genetische factor regelt de sluiting?',
      [
        'Vernauwt bij hogere portale flux en wordt vervolgens door endotheel verwijderd',
        'Blijft bij 30% van de volwassenen patent als anatomische variant',
        'Involueert via apoptose, getriggerd door HIF-1α als reactie op verhoogde zuurstoftensie',
        'Mechanisch gesloten door navelstrengtrombose voordat de hepatische circulatie is volgroeid',
      ],
      0,
      'De ductus venosus sluit functioneel enkele uren na de geboorte, wanneer de portaledruk stijgt. Endotheelproliferatie zet hem binnen enkele weken om tot het ligamentum venosum.',
    ],
    [
      'Bij coronaire autoregulatie wordt de relatie tussen coronaire bloedstroom en hartspierstofwisseling constant gehouden. Welk arteriolair mechanisme verklaart dit?',
      [
        'Adenosine uit ATP-katabolisme activeert A2A-receptoren, wat vasoconstrictie tegengaat',
        'Myogene mechanismen registreren transmurale drukveranderingen via mechanosensitieve ionkanalen',
        'Endotheliale stikstofmonoxideproductie is proportioneel aan de stofwisselingssnelheid',
        'Sympathische zenuwterugtrekking vermindert de α-adrenergische toon tijdens verhoogde metabolische vraag',
      ],
      0,
      'Hartstofwisseling genereert adenosine wanneer ATP wordt gehydrolyseerd. Adenosine werkt op A2A-receptoren om vasodilatatie te veroorzaken, wat een constante verhouding tussen doorbloeding en metabole vraag handhaaft.',
    ],
    [
      'Door welke cervicale zenuwwortels worden de scalenen (voorste, middelste, achterste) geïnnerveerd, en wat is hun mechanische rol tijdens geforceerde inademing?',
      [
        'Cervicaal 3–8; tillen ribben 1–2, verruimen de thoraxinlaat',
        'Cervicaal 1–2 alleen; comprimeren de thoraxkaviteit voor uitademing',
        'Thoracaal 1–4; stabiliseren het mediastinum',
        'Cervicaal 5–7; drukken ribben 3–6 omlaag gedurende rustige ademhaling',
      ],
      0,
      'Scalenen (C3–C8) hechten aan ribben 1–2. Gedurende geforceerde ademhaling tillen zij de ribben craniaal en vergroten zo de superieure thoraxopening.',
    ],
    [
      'De pulmonale circulatie vertoont unieke heterogeniteit tegenover de systemische circulatie. Hoe beïnvloedt de zwaartekracht via hydrostatische druk de capillaire rekrutering en de regionale V/Q?',
      [
        'Top is ventilatie-beperkt; basis is perfusie-beperkt',
        'Apicale capillairen zijn maximaal gerekruteerd; basale capillairen blijven ingeduwd wegens lage transmurale druk',
        'Zwaartekracht heeft een verwaarloosbaar effect; regionale V/Q-verschillen worden geheel bepaald door de bronchiale tonus',
        'Hydrostatische druk verhoogt de capillaire permeabiliteit uniform en vermindert de diffusieafstand overal',
      ],
      0,
      'Zwaartekracht creëert verticale hydrostatische gradiënten. Apicale zones hebben lage perfusie; basale zones hebben hoge capillaire transmurale druk en distensie.',
    ],
    [
      'Het dunnedarmepitheel vertoont een proliferatie-differentiatiegradiënt, met stamcellen in de crypten die elke 24–48 uur delen. Welke moleculaire factoren reguleren de transit-amplificatie?',
      [
        'Wnt is hoog in de crypten en BMP/TGF-β is hoog op de villi, in tegenovergestelde richting',
        'Notch-signalering blokkeert, uitsluitend in transit-amplificerende cellen, verdere deling',
        'Hedgehog-liganden, apicaal afgescheiden, verdrijven differentiërende cellen naar basaal',
        'FGF10 van mesenchymale fibroblasten stimuleert alle epitheliale proliferatie op uniforme wijze',
      ],
      0,
      'Hoog Wnt in de crypten bevordert stamcellen; verhoogd BMP op de villi bevordert differentiatie. Deze tegengestelde gradiënt stuurt gerichte migratie en celbestemming.',
    ],
    [
      'Galzuurafhankelijke activatie van de farnesoid X-receptor (FXR) in ileale enterocyten triggert welke darm- en hepatische terugkoppelingslussen?',
      [
        'FGF19 remt CYP7A1, wat de galzuursynthese verlaagt',
        'Rechtstreekse hepatocytactivering van SREBP-2 verhoogt cholesterolopname en -synthese',
        'Verminderde portale glucosesignalering downreguleert hepatische lipogenese',
        'Ileale barrièreverstoring voorkomt secundaire galzuurabsorptie en vermindert de enterohepatische circulatie',
      ],
      0,
      'Ileale FXR-activering triggert FGF19-afscheiding. FGF19 werkt op hepatische FGFR4-receptoren om SHP te induceren en CYP7A1 te onderdrukken, wat de galzuursynthese vermindert.',
    ],
    [
      'Hoe detecteert het tubuloglomerulairefeedbackmechanisme (TGF) natriumchlorideconcentratiewijzigingen bij de macula densa, en hoe moduleert het de glomerulaire filtratiesnelheid?',
      [
        'NKCC2-opname geeft adenosine af, wat de afferente arteriool vernauwt',
        'Macula densa-cellen voelen rechtstreeks angiotensine II in de juxtaglomerulaire ruimte',
        'Verhoogde intraglomerulaire druk opent rechtstreeks de mechanoreceptoren op granulaire cellen',
        'Prostaglandine E2, afgegeven door verzamelbuiscellen, remt de renineafscheiding systemisch',
      ],
      0,
      'NaCl-opname via NKCC2 verhoogt het metabolisme en de purinerge signalering. ATP/adenosine veroorzaakt vasoconstrictie van de afferente arteriool, wat de GFR en de renineafscheiding vermindert.',
    ],
    [
      'Anti-Müllerhormoon (AMH), afgescheiden door Sertolicellen, onderdrukt de Müllerbuisontwikkeling bij mannen via welke receptor en intracellulaire signalering?',
      [
        'Type II-serine/threoninekinasereceptor activeert SMAD2/3-SMAD4',
        'Oestrogeenreceptor-β op het Müllermesenchym blokkeert paracriene Wnt-signalering',
        'Notch-signalering in het mesonefrische mesenchym triggert caspase-gemedieerde Müllerbuisapoptose',
        'TrkB-tyrosinekinasereceptor in ductaal epitheel activeert FoxA2-afhankelijke differentiatie in Wolffiaanse structuren',
      ],
      0,
      'AMH bindt aan type II-serine/threoninekinasereceptoren (AMHR2) en rekruteert type I-receptoren (ALK2/3). SMAD2/3-SMAD4-activering blokkeert de genen die het lot van de Müllerbuis bepalen.',
    ],
    [
      'Het gubernaculaire mesenchym van de foetale testis brengt welke groeifactoren en transcriptiefactoren tot expressie die de daling bevorderen?',
      [
        'INSL3 van Leydigcellen activeert RXFP2 en verhoogt desmine ten behoeve van migratie',
        'BMP4 van coelomisch epitheel drijft gubernaculaire ossificatie',
        'Sonic hedgehog van mesonefrisch mesenchym triggert apoptose-gedreven gubernaculaire resorptie',
        'GDNF van de ureterische buis trekt testiculaire kiemcellen aan via RET-signalering',
      ],
      0,
      'INSL3-RXFP2-signalering in gubernaculaire cellen reguleert desmine (een myofibroblastmarker) en migratiegenen. Dit is essentieel voor de testiculaire daling.',
    ],
    [
      'De musculatisering van het diafragma omvat ingroei van phrenische (C3–C5) en lagere intercostale (T7–T12) motorneuronaxonen. Welk embryologisch proces verklaart de duale innervatie?',
      [
        'De phrenische zenuw loopt naar de centrale pees; de intercostale zenuwen lopen naar de lichaamswandspieren',
        'Het diafragma ontstaat alleen uit paraxiaal mesoderm; de duale innervatie weerspiegelt de plurisegmentale myotoombasis',
        'Phrenische en intercostale zenuwen ondergaan uitgebreide commissurale verbindingen postnataal',
        'Lagere cervicale en thoracale motorpools ondergaan Hox-genafhankelijke migratie naar het zich ontwikkelende diafragma',
      ],
      0,
      'De duale innervatie weerspiegelt de ontwikkelingsbasis: de phrenische zenuw innerveert de centrale pees (mesoderm nabij het hart); de intercostale zenuwen innerveren de musculaire periferie.',
    ],
    [
      'Het vrouwelijke orgasme omvat gecoördineerde ritmische contracties (0,8 Hz) van baarmoeder, vagina en beklemmingsspieren. Wat is de fysiologische basis van de verhoogde doorbloeding van de geslachtsorganen?',
      [
        'NO/VIP-vasocongestie en adrenergische myotonie; noradrenaline drijft de refractaire periode aan',
        'Oestrogeen verhoogt de expressie van α-adrenergische receptoren, wat vasoconstrictie en myotonie veroorzaakt; dit wordt tijdens het orgasme omgekeerd door oxytocine',
        'Parasympathische vasodilatatie gevolgd door sympathische remming tijdens de refractaire periode',
        'Pelviene splanchnische zenuwstimulatie triggert rechtstreeks ritmische baarmoedercontracties, onafhankelijk van hormonale factoren',
      ],
      0,
      'NO/VIP veroorzaken vasocongestie en verhoogde bloedstroom; sympathische tonus produceert myotonie. Na het orgasme veroorzaakt verhoogde noradrenaline adrenerg gemedieerde remming.',
    ],
    [
      'In het zich ontwikkelende cardiovasculaire systeem ondergaan endotheelcellen EMT om neurale-lijstcellen te vormen. Welk transcriptiefactornetwerk beheerst de invasie van de endocardiale kussens?',
      [
        'Snail/Slug remmen E-cadherine, samen met Wnt/β-catenine en Notch',
        'Rechtstreekse MyoD-afhankelijke myogene differentiatie van endotheelcellen tot cardiomyocyten',
        'HIF-1α-afhankelijke metabolische verschuiving van oxidatieve fosforylatie naar glycolyse',
        'Krüppel-achtige factor 4 (KLF4) reactivering van het pluripotente genexpressieprogramma',
      ],
      0,
      'Snail/Slug onderdrukken E-cadherine, wat endotheelmigratie mogelijk maakt. Wnt/β-catenine en Notch drijven samen de mesenchymale differentiatie bij de vorming van kussenweefsel.',
    ],
  ],
};
